Element.prototype.savingsForm = () => {

    const EligFormContainer = document.querySelector('.c-SavingsCard_EliForm');
    const RegFormContainer = document.querySelector('.c-SavingsCard_RegForm');


    if (EligFormContainer) {
        const setInitialState = () => {
            EligFormContainer.classList.add('js-show');
        };
        setInitialState();
    }

    const parseAsLocalDate = (date) => {
        const offset = new Date(Date.parse(date)).getTimezoneOffset();
        return new Date(Date.parse(date) + offset * 60000);
    }

    const validateDateOfBirth = () => {
        const year = document.getElementsByName('date_of_birth[year]')[0].value;
        const month = document.getElementsByName('date_of_birth[month]')[0].value;
        const day = document.getElementsByName('date_of_birth[day]')[0].value;
        const dob = parseAsLocalDate(year.padStart(4, '0') + '-' + month.padStart(2, '0') + '-' + day.padStart(2, '0'));

        if (!year || !month || !day) {
            return true; // This will be handled by 'required'
        } else if (new Date() - dob < 378683112000) { // Under 12 years
            return false;
        }

        return true;
    };

    const validDate = () => {
        const year = document.getElementsByName('date_of_birth[year]')[0].value;
        const month = document.getElementsByName('date_of_birth[month]')[0].value - 1;
        const day = document.getElementsByName('date_of_birth[day]')[0].value;

        if (!year || !month || !day) {
            return true;
        } else if (year && month && day) {
            var target = new Date(year, month, day);
            return !!(target && (target.getMonth()) == month && target.getDate() == day);
        } else {
            return false;
        }
    }

    const testRegex = (r) => (x) => r.test(x);
    jQuery.validator.addMethod('validDateOfBirth', validateDateOfBirth);
    jQuery.validator.addMethod('validDate', validDate);
    jQuery.validator.addMethod('validEmail', testRegex(/^(([0-9a-zA-Z])+([-._'+&]))*[0-9a-zA-Z]+@([-0-9a-zA-Z]+[.])+[a-zA-Z]{2,6}$/));

    jQuery('.f-SavingsElig').validate({
        rules: {
            registrant_type: "required",
            "date_of_birth[year]": {
                "required": true,
                "validDateOfBirth": true,
                "validDate": true
            },
            "date_of_birth[month]": {
                "required": true,
                "validDateOfBirth": true,
                "validDate": true
            },
            "date_of_birth[day]": {
                "required": true,
                "validDateOfBirth": true,
                "validDate": true
            },
            us_resident: {
                "required": true,
            },
            private_insurance: {
                "required": true,
            },
            employer_insurance: {
                "required": true,
            },
            over_18: {
                "required": true,
            },
            share_iqvia: {
                "required": true,
            },
        },
        groups: {
            dob: "date_of_birth[year] date_of_birth[month] date_of_birth[day]"
        },
        messages: {
            registrant_type: {
                "required": "Please confirm if you are a patient or a caregiver."
            },
            "date_of_birth[year]": {
                "required": "Please enter the patient's date of birth.",
                "validDateOfBirth": "Patient must be at least 12 years old.",
                "validDate": "Please enter a valid date of birth."
            },
            "date_of_birth[month]": {
                "required": "Please enter the patient's date of birth.",
                "validDateOfBirth": "Patient must be at least 12 years old.",
                "validDate": "Please enter a valid date of birth."
            },
            "date_of_birth[day]": {
                "required": "Please enter the patient's date of birth.",
                "validDateOfBirth": "Patient must be at least 12 years old.",
                "validDate": "Please enter a valid date of birth."
            },
            us_resident: "Please select a response.",
            private_insurance: "Please select a response.",
            employer_insurance: "Please select a response.",
            over_18: "Please confirm this statement is true.",
            share_iqvia: "Please confirm your consent.",
        },
        errorPlacement: function (error, element) {
            error.appendTo(element.closest("fieldset, div:has('.container-inline')"));
        },
        errorClass: 'f-Form_Error',
        // showErrors: console.log,
        submitHandler: (form, e) => {
            const isEligible =
            document.querySelector('input[name=us_resident]:checked').value == 'YES'
                && document.querySelector('input[name=private_insurance]:checked').value == 'YES'
                && document.querySelector('input[name=employer_insurance]:checked').value == 'NO'
                && document.querySelector('input[name=over_18]:checked').value == 'YES'
                && document.querySelector('input[name=share_iqvia]:checked').value == 'YES';
            if (isEligible) {
                document.querySelector('.c-SavingsCard.paragraph--type--savings-card-form').scrollIntoView({
                    offset:{top:1000}
                });
                EligFormContainer.classList.remove('js-show');
                RegFormContainer.classList.add('js-show');
                document.querySelector('.c-SavingsCard_Step.Step1').classList.remove('active');
                document.querySelector('.c-SavingsCard_Step.Step2').classList.add('active');
                migrateFieldsToRegistrationForm(form);

            } else {
                setTimeout(function () { // setting timeout for GTM tagging
                    window.location.pathname = '/savings-not-eligible';
                }, 200)
            }
        }
    });

    const migrateFieldsToRegistrationForm = (form) => {
        const $eligibilityForm = jQuery(form);
        const $registrationForm = jQuery('.webform-submission-savings-card-registration-form');

        const fieldnamesOrigin = [
            '[name="registrant_type"]:checked',
            '[name="date_of_birth[month]"]',
            '[name="date_of_birth[day]"]',
            '[name="date_of_birth[year]"]'
        ];
        const fieldnamesDist = [
          '[name="registrant_type"]',
          '[name="eligibility_dob_month"]',
          '[name="eligibility_dob_day"]',
          '[name="eligibility_dob_year"]'
        ];

        fieldnamesOrigin.forEach((fName,i) => {
            const fValue = $eligibilityForm.find(fName)[0].value;
            const hiddenField = $registrationForm.find(fieldnamesDist[i]);
            hiddenField[0].value = fValue;
        })

        populateEpilepsyCookie();
    }
    var response;
    function getState(){
        return jQuery.ajax({
            url: '/api/verify-zipcode?zipcode=' + document.getElementById('edit-mailing-address-postal-code').value + '&state=' + document.querySelector('select#edit-mailing-address-state-province').value,
            type: 'POST',
            data: 'JSON',
            async: false,
            success: function (data, textStatus, jqXHR) {
                response = (data.valid == true) ? true : false;
            }
        });
    }

    jQuery.validator.addMethod('validState',
        function () {
            jQuery('select#edit-mailing-address-state-province').on('change', function () {
                jQuery('input#edit-mailing-address-postal-code').valid();
            });
            getState();
            return response;
        }
    );

    jQuery('.f-SavingsReg').validate({
        rules: {
            first_name: {
                required: true,
                maxlength: 50,
            },
            last_name: {
                required: true,
                maxlength: 50,
            },
            email: {
                required: true,
                validEmail: true,
                maxlength: 75,
            },
            "zip_code[postal_code]": {
                required: true,
                digits: true,
                minlength: 5,
                maxlength: 5,
            },
            nayzilam_use_status: "required",
            mobile_phone_number: {
                required: "#edit-sms-kit-sms-kit:checked",
                maxlength: 12,
                phoneUS: true,
            },
            "mailing_address[address]": {
                required: "#edit-direct-mail-options-welcome-kit:checked,#edit-direct-mail-options-training-kit:checked",
                maxlength: 75,
            },
            "mailing_address[address_2]": {
                maxlength: 75,
            },
            "mailing_address[city]": {
                required: "#edit-direct-mail-options-welcome-kit:checked,#edit-direct-mail-options-training-kit:checked",
                maxlength: 50,
            },
            "mailing_address[state_province]": {
                required: "#edit-direct-mail-options-welcome-kit:checked,#edit-direct-mail-options-training-kit:checked",
            },
            "mailing_address[postal_code]": {
                required: "#edit-direct-mail-options-welcome-kit:checked,#edit-direct-mail-options-training-kit:checked",
                digits: true,
                maxlength: 5,
                validState: true,
            },
        },
        messages: {
            first_name: "Please provide your first name.",
            last_name: "Please provide your last name.",
            email: {
                "required": "Please provide your email address.",
                "validEmail": "Please enter a valid email address.",
            },
            "zip_code[postal_code]": "Please enter a valid ZIP code (e.g., 12345).",
            mobile_phone_number: "Please provide a valid phone number.",
            nayzilam_use_status: "Please select the statement that best describes you or the person you are representing.",
            "mailing_address[address]": "Please provide your mailing address.",
            "mailing_address[city]": "Please provide your city.",
            "mailing_address[state_province]": "Please provide your state.",
            "mailing_address[postal_code]": {
                required: "Please enter a valid ZIP code (e.g., 12345).",
                validState: "Please provide the correct ZIP code for your selected state.",
            },
        },
        errorPlacement: function (error, element) {
            const wrapper = element[0].name == 'nayzilam_use_status' ? element.closest("fieldset") : element.closest("fieldset, div.form-item");
            // console.log(element, wrapper)
            error.appendTo(wrapper);
        },
        errorClass: 'f-Form_Error',
    });

    jQuery('#edit-mobile-phone-number').keyup(function () {
        jQuery(this).val(jQuery(this).val().replace(/(\d{3})\-?(\d{3})\-?(\d{4})/, '$1-$2-$3'));
    });


}

// Only run the function whenever there is an instance of a Eligibility Tool
if (document.querySelector('.c-SavingsCard')) {
    jQuery(document).ready(function () {
        let zipCode = document.querySelector('input#edit-zip-code-postal-code');;
        let maZip = document.querySelector('input#edit-mailing-address-postal-code');
        const checkBox = document.querySelector('input#edit-direct-mail-options-welcome-kit');
        const checkBox2 = document.querySelector('input#edit-direct-mail-options-training-kit');

        var populateZipcode = function (zipcode) {
            if (zipcode !== '') {
                zipcode.setAttribute('value', zipcode.value);
                maZip.setAttribute('value', zipcode.value);
                maZip.value = zipcode.value;
            }
        };
        if ( zipCode ) {
            jQuery('input#edit-mailing-address-postal-code').one('input keyup blur', function () {
                populateZipcode(zipCode);
                checkBox.addEventListener('click', populateZipcode(zipCode));
                checkBox2.addEventListener('click', populateZipcode(zipCode));
                maZip.setAttribute('aria-invalid', 'false');
                maZip.classList.add('valid');
                setTimeout(() => {
                    document.getElementById('edit-mailing-address-postal-code').value = document.getElementById('edit-zip-code-postal-code').value;
                }, 500);
            });
        }
    });
    document.querySelector('.c-SavingsCard').savingsForm();
}
